<template lang="">
	<div id="content">
		<div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">기타 관리</a> &gt; <strong>캠페인 카테고리 등록</strong></div>
			<h2 class="h_sub">캠페인 카테고리 등록</h2>
		</div>

    <CampaignCategoryManageCreateForm/>
  </div>
</template>

<script>
import CampaignCategoryManageCreateForm from '@/components/admin/etc/CampaignCategoryManageCreateForm.vue';

export default {
  components: {
    CampaignCategoryManageCreateForm: CampaignCategoryManageCreateForm
  }
}
</script>
<style lang="">

</style>